import React, { useEffect, useState, useRef } from "react";
import Spinner from "../../components/Tools/spinner";
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import { useSelector } from 'react-redux';
import { 
    fetchFailedInvoiceDetails, 
    getBeneficiaryAccountListBeneficiaryId,
    createDuplicateInvoice,
 } from "../../helper/Api";
import { toast } from "react-toastify";
import { useParams, useNavigate } from 'react-router-dom';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
} from "@mui/material";

const FailedInvoiceEdit = () => {
    const [loading, setLoading] = useState(false);
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    const { id } = useParams();
    const [bankAccounts, setBankAccounts] = useState([]);
    const [formData, setFormData] = useState({
        id: id,
        vendor_account_id: '',
    });
    const navigate = useNavigate();
    const getInvoiceDetails = async () => {
        try {
            setLoading(true);
            const res = await fetchFailedInvoiceDetails(id); // Hardcoded ID for example
            setLoading(false);
            if(res.data.status) {
                setInvoiceDetails(res.data.result);
                const accountRes = await getBeneficiaryAccountListBeneficiaryId(res.data.result.vendor_id);
                if(accountRes.data.status && accountRes.data.result.length > 0) {
                    const filteredAccount = accountRes.data.result.filter(acc => acc.id !== res.data.result.vendor_account_id);
                    setBankAccounts(filteredAccount);
                }
            } else {
                toast.error('Unable to fetch invoices', {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }catch(err) {
            setLoading(false);
            toast.error('Unable to fetch invoices', {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }
    useEffect(() => {
        getInvoiceDetails();
    }, [id]);

    const handleFormData = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const handleVendorAccountChange = async () => {
        try {
            setLoading(true);
            if(!formData.vendor_account_id) {
                toast.error('Please select vendor account', {
                    position: toast.POSITION.TOP_CENTER,
                });
                setLoading(false);
                return;
            }
            const res = await createDuplicateInvoice(formData);
            setLoading(false);
            if(res.data.status) {
                toast.success('Vendor account updated successfully', {
                    position: toast.POSITION.TOP_CENTER,
                });
                navigate('/failed-payments');
            } else {
                toast.error('Unable to update vendor account', {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }catch(err) {
            toast.error('Unable to update vendor account', {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Edit Failed Invoice</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Edit Failed Invoice"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>

            <div className="body m-2 bg-white p-3 rounded-3 edit_failed_invoice_details">
                <div className="row">
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Sanction Order No</label>
                        <h5>{invoiceDetails?.sanction_order_no}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Sanction Order Date</label>
                        <h5>{invoiceDetails?.sanction_order_date}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Voucher Order No</label>
                        <h5>{invoiceDetails?.voucher_no}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Voucher Order Date</label>
                        <h5>{invoiceDetails?.voucher_date}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Invoice No.</label>
                        <h5>{invoiceDetails?.invoice_no}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Invoice Date</label>
                        <h5>{invoiceDetails?.invoice_date}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Invoice Amount</label>
                        <h5>{invoiceDetails?.invoice_value}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Payable Amount</label>
                        <h5>{invoiceDetails?.payable_amount}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Account Holder Name</label>
                        <h5>{invoiceDetails?.bank_details?.beneficiary_name}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Account No</label>
                        <h5>{invoiceDetails?.bank_details?.account_no}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Bank Name</label>
                        <h5>{invoiceDetails?.bank_details?.bank_name}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>Branch Name</label>
                        <h5>{invoiceDetails?.bank_details?.branch_name}</h5>
                    </div>
                    <div className="col-3 d-flex flex-column gap-1">
                        <label>IFSC Code</label>
                        <h5>{invoiceDetails?.bank_details?.ifsc_code}</h5>
                    </div>
                    <div className="col-6 d-flex flex-column gap-1">
                        <label>Payment Failed Reason</label>
                        <h5>{invoiceDetails?.reason}</h5>
                    </div>
                    <div className="col-12">
                        <hr />
                    </div>
                    <div className="col-md-8">
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Vendor Account</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={formData.vendor_account_id || ""}
                                label="Vendor Account"
                                name="vendor_account_id"
                                onChange={handleFormData}
                            >
                                {bankAccounts.map((m) => (
                                <MenuItem key={m.id} value={m.id}>
                                    {m.beneficiary_name} - {m.account_no} ({m.bank_name})
                                </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-4">
                        <button className="submit_button" onClick={() => handleVendorAccountChange()}>Update Vendor Account</button>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default FailedInvoiceEdit;